import React from 'react';
import ReactDOM from 'react-dom';

import EnhancedApp from './app/EnhancedApp';

ReactDOM.render(<EnhancedApp />, document.getElementById('root'));
